














































































































































































































































































import { ciPlot } from '~/icons/source/brand/plot'
import GoogleLoginButton from '~/components/shared/social-login/GoogleLoginButton.vue'
import FacebookLoginButton from '~/components/shared/social-login/FacebookLoginButton.vue'
import { faAt } from '@fortawesome/free-solid-svg-icons'
import { capitalizeString } from '~/utils/string'
import UserAuthService from '~/services/login/UserAuthService'
import FlashService from '~/services/flash/FlashService'
import { ClientFlashMessageType, SnackbarVariant } from '~/models/flash/types'
import { mapGetters } from 'vuex'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import PasswordFormGroup from '~/pages/shared/login_register/PasswordFormGroup.vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import RecaptchaService from '~/services/recaptcha/RecaptchaService'
import {
  FallbackWidgetRenderResult,
  RecaptchaFormToken
} from '~/models/recaptcha/types'
import { objectsEqual } from '~/utils/object'
import CRecaptchaText from '~/components/shared/configurable/CRecaptchaText.vue'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { HttpStatus } from '~/constants/http'
import ScrollService from '~/services/scroll/ScrollService'
import { defineComponent } from '@nuxtjs/composition-api'
import { ciCar } from '~/icons/source/brand/car'
import { APP_NS } from '~/store/modules/shared/app/state'
import AppleLoginButton from '~/components/shared/social-login/AppleLoginButton.vue'
import { Variant } from '~/models/app/variant'
import CInfoTooltip from '~/components/shared/configurable/info/CInfoTooltip.vue'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'

export default defineComponent({
  components: {
    CFormError,
    CRecaptchaText,
    PasswordFormGroup,
    FacebookLoginButton,
    GoogleLoginButton,
    CInfoTooltip,
    AppleLoginButton
  },
  middleware: 'already-logged-in',
  async fetch() {
    try {
      const { schema } = await this.userAuthService.getGuestRegisterSchema()
      this.schema = schema
    } catch (error) {
      this.$logger.captureError(error)
    }
  },
  data() {
    return {
      prFocused: false,
      usFocused: false,
      loading: false,
      username: '',
      password: '',
      passwordRepeat: '',
      acceptedTerms: false,
      invalidUsername: '',
      invalidPass: '',
      invalidPassRepeat: '',
      invalidTerms: null,
      invalidRecaptchaToken: null,
      errors: {},
      recaptchaToken: null,
      showRecaptcha2: false,
      recaptcha2Loaded: false,
      schema: {},
      reactivateUserId: '',
      typingPasswordError: ''
    }
  },
  computed: {
    ...mapDeps({
      userAuthService: UserAuthService,
      flashService: FlashService,
      recaptchaService: RecaptchaService
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapGetters(APP_NS, {
      isPlot: 'isPlot',
      isCar: 'isCar',
      siteName: 'siteName'
    }),
    ...mapDeps({
      scrollService: ScrollService
    }),
    title() {
      return this.$t('register at {site}', {
        site: this.siteDomain
      })
    },
    usernameState() {
      return this.getState('username')
    },
    passState() {
      return this.getState('password')
    },
    repeatPassState() {
      if (!this.passwordRepeat) {
        return null
      }

      if (this.passwordRepeat?.length) {
        if (!this.prFocused && this.password !== this.passwordRepeat) {
          return false
        }
      }

      return null
    },
    icons() {
      return {
        plot: ciPlot,
        at: faAt,
        car: ciCar
      }
    },
    mainIcon() {
      return this.isPlot ? this.icons.plot : this.icons.car
    },
    siteDomain() {
      return capitalizeString(process.env.DOMAIN || 'car.gr')
    },
    passError() {
      if (
        (this.errors.password && this.getState('password') === false) ||
        this.typingPasswordError
      ) {
        return this.errors.password
      }
      return null
    },
    passRepeatError() {
      if (this.repeatPassState === false) {
        return this.$t("passwords don't match")
      } else if (
        this.errors.password_repeat &&
        this.getState('password_repeat') === false
      ) {
        return this.errors.password_repeat
      }
      return null
    },
    buttonVariant() {
      if (this.isCar) {
        return Variant.PRIMARY
      }
      return Variant.BLUE
    },
    formValidationBuilder() {
      return this.$dep(FormValidationBuilder)
    }
  },
  methods: {
    validate() {
      const errors: [] =
        this.errors &&
        Object.keys(this.errors).filter(e => {
          if (
            (e === 'accepted_terms' &&
              this.getState('accepted_terms') === false) ||
            (e === 'username' && this.getState('username') === false)
          ) {
            return true
          } else if (
            this.errors[e] &&
            !['username', 'accepted_terms'].includes(e)
          ) {
            return true
          }
          return false
        })

      if (this.repeatPassState === false || errors.length > 0) {
        return false
      }

      return true
    },
    async backToRegister() {
      this.reactivateUserId = ''
      this.username = ''
      this.password = ''
      this.passwordRepeat = ''
      this.acceptedTerms = false
      await this.$nextTick()
      await this.resetVars()
    },
    async resetVars() {
      this.$refs.password.resetShowPass()
      this.$refs.passwordreset.resetShowPass()

      await this.$nextTick()

      this.invalidUsername = ''
      this.invalidPass = ''
      this.invalidPassRepeat = ''
      this.invalidRecaptchaToken = null
      this.invalidTerms = null

      this.loading = false

      this.errors = {}
    },
    async register() {
      if (!this.validate()) {
        return
      }

      await this.resetVars()
      this.loading = true
      try {
        if (!this.showRecaptcha2) {
          const token = await this.recaptchaService.getToken('guest_register')
          this.recaptchaToken = {
            v: 3,
            token
          }
        }
        await this.userAuthService.registerGuest(
          this.username,
          this.password,
          this.passwordRepeat,
          this.acceptedTerms,
          this.recaptchaToken
        )

        this.successRedirect()
      } catch (error) {
        this.loading = false
        const validationErrors = error?.response?.data?.data?.errors
        if (!validationErrors) {
          this.$logger.captureError(error)
          return
        }

        if (
          error?.response?.data?.status === HttpStatus.UNPROCESSABLE_ENTITY &&
          validationErrors?.username?.user_id
        ) {
          this.reactivateUserId = validationErrors?.username?.user_id
          return
        }

        this.errors = validationErrors

        if (this.errors?.username) {
          this.invalidUsername = this.username
        }
        if (this.errors?.password) {
          this.invalidPass = this.password
        }
        if (this.errors?.password_repeat) {
          this.invalidPassRepeat = this.passwordRepeat
        }
        if (this.errors?.accepted_terms) {
          this.invalidTerms = this.acceptedTerms
        }

        if (this.errors?.recaptcha_token) {
          this.invalidRecaptchaToken = this.recaptchaToken
          this.onRecaptchaError()
        }

        this.errorScroll()
      }
    },
    async resendActivation() {
      this.loading = true
      try {
        await this.userAuthService.resendActivationEmail(this.reactivateUserId)
        this.successRedirect()
      } catch (error) {
        this.$logger.captureError(error)
        this.$snackbar.error(
          this.$t('an error occurred please try again later')
        )
      } finally {
        this.loading = false
      }
    },
    successRedirect() {
      this.flashService.redirectWithFlash(
        '/',
        ClientFlashMessageType.GUEST_REGISTER_SUCCESS,
        {
          email: this.username,
          showAsSnackbar: this.isMobile, // Snackbar only for mobile users
          snackbarVariant: SnackbarVariant.INFO,
          text: `${this.$t('we have sent you a confirmation email at')} ${
            this.username
          }`
        }
      )
    },
    async onRecaptchaError() {
      if (!this.showRecaptcha2) {
        this.showRecaptcha2 = true
        if (!this.recaptcha2Loaded) {
          this.recaptcha2Loaded = true
          await this.$nextTick()
          const {
            token
          }: FallbackWidgetRenderResult = await this.recaptchaService.renderFallbackWidget(
            'g-recaptcha'
          )
          this.recaptchaToken = {
            v: 2,
            token
          } as RecaptchaFormToken
        } else {
          this.recaptchaService.reset()
        }
      }
    },
    getState(fieldName: string) {
      if (this.errors && this.errors[fieldName]) {
        switch (fieldName) {
          case 'username':
            return this.username === this.invalidUsername ? false : null
          case 'password':
            return this.password === this.invalidPass ||
              this.typingPasswordError
              ? false
              : null
          case 'password_repeat':
            return this.passwordRepeat === this.invalidPassRepeat ? false : null
          case 'accepted_terms':
            return this.acceptedTerms === this.invalidTerms ? false : null
          case 'recaptcha_token':
            return objectsEqual(this.recaptchaToken, this.invalidRecaptchaToken)
              ? false
              : null
        }
        return false
      }
      return null
    },
    errorScroll() {
      if (process.client && this.isMobile) {
        setTimeout(() => {
          let firsterror = document.querySelector('.c-form-error')
          if (firsterror.length) {
            firsterror = firsterror[0]
          }
          if (firsterror) {
            const options = {
              easing: 'ease-in',
              offset: this.isPlot ? -200 : -100,
              duration: 500
            }

            this.scrollService.scrollTo(firsterror, options)
          }
        }, 100)
      }
    },
    onInvalid(e) {
      const input = e.target
      const header = document.getElementById('header-section')
      let headerHeight = 0
      if (header) {
        headerHeight = header.offsetHeight
      }

      let elementOffset = headerHeight
      let offsetElem = input
      if (offsetElem.offsetParent) {
        do {
          elementOffset += offsetElem.offsetTop
          offsetElem = offsetElem.offsetParent
        } while (offsetElem)
      }

      const pageOffset = window.pageYOffset + headerHeight

      if (elementOffset > pageOffset + input.offsetHeight) {
        return
      }

      this.scrollService.scrollTo(input, -1, {
        easing: 'ease-out',
        offset: -headerHeight
      })
    },
    handlePasswordInput(pass: string) {
      const errorMsg = this.formValidationBuilder
        .new()
        .passwordIsValid(pass)
        .validate()

      this.typingPasswordError = errorMsg
      this.$set(this.errors, 'password', errorMsg)
    }
  },
  head() {
    return {
      title: this.title
    }
  }
})
